import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { FinanciamientoApiService } from 'src/app/services/financiamiento-reusable.service';

@Component({
  selector: 'app-mensaje-financiamiento',
  templateUrl: './mensaje-financiamiento.component.html',
  styleUrls: ['./mensaje-financiamiento.component.scss']
})
export class MensajeFinanciamientoComponent implements OnInit {
  flagMessage: number;
  data: any;
  constructor(private financiamientoApiService: FinanciamientoApiService,
              private globals: Globals,
              private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  ngOnInit() {
    this.getRouteData();
  }

  getRouteData() {
    this.flagMessage = this.globals.admin_msg_shared;
  }

}
